export const SECONDS_TO_MILLISECONDS = 1000;
export const MINUTES_TO_SECONDS = 60;
export const HOURS_TO_MINUTES = 60;
export const DAYS_TO_HOURS = 24;
export const YEARS_TO_DAYS = 365;
export const YEARS_TO_MONTHS = 12;

export const MILLISECONDS_TO_SECONDS = 1 / SECONDS_TO_MILLISECONDS;
export const SECONDS_TO_MINUTES = 1 / MINUTES_TO_SECONDS;
export const MINUTES_TO_HOURS = 1 / HOURS_TO_MINUTES;
export const HOURS_TO_DAYS = 1 / DAYS_TO_HOURS;
export const DAYS_TO_YEARS = 1 / YEARS_TO_DAYS;

export const ONE_YEAR_SECONDS =
  YEARS_TO_DAYS * DAYS_TO_HOURS * HOURS_TO_MINUTES * MINUTES_TO_SECONDS;

export const A_ROUGH_AVERAGE_OF_HOW_MANY_DAYS_THERE_ARE_IN_A_MONTH = 30;
export const TWO_DAYS = 2;
export const ONE_HOUR = 1;

export const TWO_WEEKS_TO_DAYS = 14;
export const FOUR_WEEKS_TO_DAYS = 28;
